import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getColor } from "utils/colors";
import { valorAPesos } from "utils/formatters";

const getRows = (data, handleOpenMenu) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        categoria: (
          <SoftBox
            sx={{
              cursor: "pointer",
              pl: 4,
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography variant="caption" color="secondary" fontWeight="medium">
              {item?.categoria}
            </SoftTypography>
          </SoftBox>
        ),
        importe: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography variant="caption" color="secondary" fontWeight="medium">
              {item?.importe ? valorAPesos(item?.importe) : `${item?.porcentaje} %`}
            </SoftTypography>
          </SoftBox>
        ),
        // anio: (
        //   <SoftBox
        //     sx={{
        //       cursor: "pointer",
        //     }}
        //     onClick={(e) => handleOpenMenu(e, item)}
        //   >
        //     <SoftTypography variant="caption" color="secondary" fontWeight="medium">
        //       {item?.anio}
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getColor("gobSecondary"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }
  return rows;
};

const columns = [
  { name: "categoria", desc: "Categoría", align: "left", noOrder: true },
  { name: "importe", desc: "Importe / Porcentaje", align: "center", noOrder: true },
  // { name: "anio", desc: "Año", align: "left" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
